// import React, { useEffect, useState } from 'react'
// import { Dropdown } from 'react-bootstrap'
// import "../../../css/customStyle.css"
// import DataTable, { createTheme } from 'react-data-table-component';
// import DataTableExtensions from 'react-data-table-component-extensions';
// import axios from "axios";
// import { useSelector, useDispatch } from 'react-redux'
// import { NetworkDatabaseAction, CSVUploadAction, PAG_maindashboardAction } from "../../../store/actions/dashboardActions"
// import TrendingDownIcon from '@mui/icons-material/TrendingDown';
// import TrendingUpIcon from '@mui/icons-material/TrendingUp';
// import DateTimeRangeContainer from 'react-advanced-datetimerange-picker'
// import { FormControl } from 'react-bootstrap'
// import moment from "moment"
// import "react-datepicker/dist/react-datepicker.css";

// import "../../../css/custom.css"

// // import { Chart } from "react-google-charts";
// import Chart from 'react-apexcharts';
// import { GetChartAction } from '../../../store/actions/createTicketManageFields';
// import { dashboardVendor, ttAgingVendor, ttCountVendor } from '../../../common/config';
// import DatePicker from "react-datepicker";
// import { CustomInput } from 'reactstrap';
// const VendorDashboard = () => {
//   let now = new Date();
//   let startt = moment(new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0));
//   let endd = moment(startt).add(1, "days").subtract(1, "seconds");
//   const [accordianState, setAccordianState] = useState(false)
//   const [oneTime, setoneTime] = useState(true)
//   const [oneTime1, setoneTime1] = useState(true)
//   const [siteFile, uploadedFile] = useState();
//   const [remarks, setRemarks] = useState();
//   const [changeWeek, setChangeWeek] = useState();
//   const [notchangeWeek, setnotchangeWeek] = useState();
//   const [Week, setWeekName] = useState("Week");
//   const [adingDate, setadingDate] = useState();
//   const [start, setstart] = useState(startt);
//   const [end, setend] = useState(endd);
//   const [startDate, setStartDate] = useState();

//   const [dateRange, setDateRange] = useState([null, null]);
//   const [rangestartDate, rangeendDate] = dateRange;

//   let columns = []

//   let morethanenew = []
//   let lessthannew = []
//   let assignvendornew = []
//   let rowData = []
//   var posts = []
//   var new_posts = []
//   var tableData_new = {};

//   var TotalTicket = "--"
//   var piechartdata = [
//     ["Task", "Hours per Day"]
//   ];

//   var piechartoptions = {
//     is3D: true,
//     backgroundColor: 'transparent',
//     responsive: true,

//     legend: {
//       position: 'right',
//       textStyle: { fontSize: 10, color: 'black' },

//     },
//   };

//   var downtable_columns = []
//   var downtable_data = []

//   var unique_weeks = []
//   var vendor = []
//   var open = []
//   var close = []

//   const count = useSelector((state) => {
//     let vendornew = []
//     let opennew = []
//     let closenew = []

//     let weekks = []
//     let ticketsData;
//     console.log(state, "state")
//     // if (state.chartState.ttVendorChartData && state.chartState.ttVendorChartData.length > 0) {
//     let rowData = state.chartState.ttVendorChartData ? state.chartState.ttVendorChartData.length > 0 ? state.chartState.ttVendorChartData : [] : []
//     let agingrowData = state.chartState.ttVendorAgingChartData ? state.chartState.ttVendorAgingChartData.length > 0 ? state.chartState.ttVendorAgingChartData : [] : []

//     ticketsData = state.chartState.vendorDashboard ? state.chartState.vendorDashboard : {}

//     if (oneTime1 == oneTime1) {
//       if (agingrowData && agingrowData.length > 0) {
//         // setoneTime1(false)
//         console.log("agingrowData", agingrowData)
//         agingrowData.map((item) => {

//           let inner = item.add
//           console.log("agingrowDatainner", inner)

//           if (inner.length == 2) {
//             if (inner[0].status == "greater") {
//               morethanenew.push(inner[0].count)
//             }
//             if (inner[0].status == "less") {
//               lessthannew.push(inner[0].count)
//             }
//             if (inner[1].status == "greater") {
//               morethanenew.push(inner[1].count)
//             }
//             if (inner[1].status == "less") {
//               lessthannew.push(inner[1].count)
//             }
//           }
//           if (inner.length == 1) {
//             if (inner[0].status == "less") {
//               lessthannew.push(inner[0].count)
//               morethanenew.push(0)
//             }
//             if (inner[0].status == "greater") {
//               morethanenew.push(inner[0].count)
//               lessthannew.push(0)
//             }
//           }
//           if (inner.length == 0) {
//             morethanenew.push(0)
//             lessthannew.push(0)
//           }
//           assignvendornew.push(item._id.vendor)
//         })

//       }
//     }

//     if (rowData) {
//       rowData.map((item) => {
//         console.log(item.vendor, item.weekNumber == "08", "item.weekNumber==08", item.status)
//         if (unique_weeks.indexOf(item.weekNumber) > -1) {
//           unique_weeks.push(item.weekNumber)
//         }

//         if (1 == 1) {
//           console.log(item.data, "item.data")
//           let inner = item.data

//           console.log(inner[0].status == "Close", "inner")
//           if (inner.length == 2) {
//             console.log(inner[0].status, "innerstatus")
//             if (inner[0].status == "Open") {
//               console.log(inner[0].count, "innerstatus")
//               opennew.push(inner[0].count)
//             }
//             if (inner[0].status == "Close") {
//               console.log(inner[0].count, "innerstatus")
//               closenew.push(inner[0].count)
//             }

//             if (inner[1].status == "Open") {
//               console.log(inner[1].count, "innerstatus")
//               opennew.push(inner[1].count)
//             }
//             if (inner[1].status == "Close") {
//               console.log(inner[1].count, "innerstatus")
//               closenew.push(inner[1].count)
//             }

//           }

//           if (inner.length == 1) {
//             console.log(inner[0].status, "innerstatus")
//             if (inner[0].status == "Open") {
//               console.log(inner[0].count, "innerstatus")
//               opennew.push(inner[0].count)
//               closenew.push(0)
//             }
//             if (inner[0].status == "Close") {
//               console.log(inner[0].count, "innerstatus")
//               closenew.push(inner[0].count)
//               opennew.push(0)
//             }

//           }

//           if (inner.length == 0) {

//             closenew.push(0)
//             opennew.push(0)

//           }

//           vendornew.push(item._id.vendor)
//           console.log(opennew, closenew, vendornew, "innerdsadaas")

//         }
//       })
//     }

//     for (let i = 1; i <= 52; i++) {
//       let weekday = "0" + i.toString()
//       if (changeWeek == weekday) {
//         weekks.push(<option selected value={i < 10 ? "0" + i.toString() : i.toString()}>{i < 10 ? "0" + i.toString() : i.toString()}</option>)
//       } else {
//         weekks.push(<option value={i < 10 ? "0" + i.toString() : i.toString()}>{i < 10 ? "0" + i.toString() : i.toString()}</option>)
//       }
//     }

//     return { opennew, closenew, vendornew, weekks, ticketsData, lessthannew, morethanenew, assignvendornew }

//   })

//   console.log(count, "countcountcount")
//   const dispatch = useDispatch()
//   function accordianHandler() {
//     setAccordianState(!accordianState)
//   }

//   let ttvardata = {
//     series: [
//       {
//         name: "Open",
//         data: count.opennew,
//       },
//       {
//         name: "Close",
//         data: count.closenew,
//       },
//     ],
//     options: {
//       title: {
//         text: "Vendor TT Open Vs Closed "+ Week +" "+ changeWeek,
//         align: 'left',
//         margin: 10,
//         offsetX: 0,
//         offsetY: 0,
//         floating: false,
//         style: {
//           fontSize: '14px',
//           fontWeight: 'bold',
//           fontFamily: undefined,
//           color: '#263238'
//         },
//       },
//       chart: {
//         // background: 'linear-gradient(135deg, #143b64 0%, #0655a8 100%)',
//         background: '',
//         dropShadow: {
//           enabled: false,
//           enabledOnSeries: undefined,
//           top: 0,
//           left: 0,
//           blur: 3,
//           color: 'black',
//           opacity: 1
//         },
//         type: "bar",
//         height: 250,
//         toolbar: {
//           show: true,
//         },
//       },

//       plotOptions: {
//         bar: {
//           horizontal: false,
//           columnWidth: "55%",
//           // endingShape: "rounded",
//         },
//       },
//       dataLabels: {
//         enabled: true,
//       },

//       legend: {
//         show: true,
//         fontSize: "12px",
//         fontWeight: 300,

//         labels: {
//           colors: "#000000",
//         },
//         position: "bottom",
//         horizontalAlign: "center",
//         markers: {
//           width: 19,
//           height: 19,
//           strokeWidth: 0,
//           radius: 19,
//           margin: 1,
//           strokeColor: "#fff",
//           fillColors: ["#f16722", "#143b64"],
//           offsetX: 0,
//           offsetY: 0,
//         },
//       },
//       yaxis: {
//         labels: {
//           formatter: function (val) {
//             return val?val.toFixed(0):""
//           },
//           style: {
//             colors: "#000000",
//           },
//         },

//       },
//       // stroke: {
//       //   show: true,
//       //   width: 2,
//       //   colors: ["black"],

//       // },
//       xaxis: {
//         categories: count.vendornew,
//         labels: {
//           style: {
//             colors: "#000000",
//           },
//         },
//         axisBorder: {
//           show: false,
//         },
//         axisTicks: {
//           show: true,
//         },

//       },
//       // grid: {
//       //   yaxis: {
//       //     lines: {
//       //       show: false
//       //     },
//       //   },
//       // },
//       fill: {
//         colors: ["#f16722", "#143b64"],
//         // backgroundColor:"#ff00ff",
//         opacity: 1,
//       },
//       // tooltip: {
//       //   y: {
//       //     formatter: function (val) {
//       //       return val + " Ticket";
//       //     },
//       //   },
//       // },
//     }
//   }

//   let agingvardata = {
//     series: [
//       {
//         name: "Less Than 48 Hrs",
//         data: count.lessthannew,
//       },
//       {
//         name: "More Than 48 Hrs",
//         data: count.morethanenew,
//       },
//     ],
//     options: {
//       title: {
//         text: "Current TT Ageing As of " + adingDate,
//         align: 'left',
//         margin: 10,
//         offsetX: 0,
//         offsetY: 0,
//         floating: false,
//         style: {
//           fontSize: '14px',
//           fontWeight: 'bold',
//           fontFamily: undefined,
//           color: '#263238'
//         },
//       },
//       chart: {
//         // background: 'linear-gradient(135deg, #143b64 0%, #0655a8 100%)',
//         background: '',
//         dropShadow: {
//           enabled: false,
//           enabledOnSeries: undefined,
//           top: 0,
//           left: 0,
//           blur: 3,
//           color: 'black',
//           opacity: 1
//         },
//         type: "bar",
//         height: 250,
//         toolbar: {
//           show: true,
//         },
//       },

//       plotOptions: {
//         bar: {
//           horizontal: false,
//           columnWidth: "55%",
//           // endingShape: "rounded",
//         },
//       },
//       dataLabels: {
//         enabled: true,
//       },

//       legend: {
//         show: true,
//         fontSize: "12px",
//         fontWeight: 300,

//         labels: {
//           colors: "#000000",
//         },
//         position: "bottom",
//         horizontalAlign: "center",
//         markers: {
//           width: 19,
//           height: 19,
//           strokeWidth: 0,
//           radius: 19,
//           margin: 1,
//           strokeColor: "#fff",
//           fillColors: ["#f16722", "#143b64"],
//           offsetX: 0,
//           offsetY: 0,
//         },
//       },
//       yaxis: {
//         labels: {
//           formatter: function (val) {
//             return val?val.toFixed(0):""
//           },
//           style: {
//             colors: "#000000",
//           },
//         },

//       },
//       // stroke: {
//       //   show: true,
//       //   width: 2,
//       //   colors: ["black"],

//       // },
//       xaxis: {
//         categories: count.assignvendornew,
//         labels: {
//           style: {
//             colors: "#000000",
//           },
//         },
//         axisBorder: {
//           show: false,
//         },
//         axisTicks: {
//           show: true,
//         },

//       },
//       // grid: {
//       //   yaxis: {
//       //     lines: {
//       //       show: false
//       //     },
//       //   },
//       // },
//       fill: {
//         colors: ["#f16722", "#143b64"],
//         // backgroundColor:"#ff00ff",
//         opacity: 1,
//       },
//       // tooltip: {
//       //   y: {
//       //     formatter: function (val) {
//       //       return val + " Ticket";
//       //     },
//       //   },
//       // },
//     }
//   }

//   function changeWeekF(e, typ = undefined) {
//     if (typ == "no") {
//       console.log(e, "changeWeek")
//       setChangeWeek(e)
//     } else {
//       console.log(e.target.value, "changeWeek")
//       setChangeWeek(e.target.value)
//     }
//   }

//   let percent = "--";
//   let type = 0;
//   console.log(count.ticketsData, "count.ticketsData")
//   if (count.ticketsData) {
//     if (oneTime && count.ticketsData.currentWeek) {
//       setoneTime(false)
//       setChangeWeek(count.ticketsData.currentWeek)
//       // changeWeekF(count.ticketsData.currentWeek, "no")
//       // console.log(count.ticketsData.currentWeek, "count.ticketsData")
//       setadingDate(count.ticketsData.adingDate)
//     }

//     if (count.ticketsData.yesterdayOpen == 0) {
//       percent = count.ticketsData.todayOpen * 100
//       type = 1
//     }
//     else if (count.ticketsData.todayOpen == 0) {
//       percent = count.ticketsData.yesterdayOpen * 100
//       type = 2
//     }
//     else if (count.ticketsData.todayOpen > count.ticketsData.yesterdayOpen) {
//       percent = count.ticketsData.todayOpen * 100 / count.ticketsData.yesterdayOpen
//       type = 1
//     }
//     else if (count.ticketsData.todayOpen < count.ticketsData.yesterdayOpen) {
//       percent = count.ticketsData.yesterdayOpen * 100 / count.ticketsData.todayOpen
//       type = 2
//     }

//     else if (count.ticketsData.todayOpen == count.ticketsData.yesterdayOpen) {
//       percent = "100"
//     }

//     percent = percent + "%"
//   }

//   // let now = new Date();
//   // let start = moment(new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0));
//   // let end = moment(start).add(1, "days").subtract(1, "seconds");
//   let ranges = {
//     "Today Only": [moment(start), moment(end)],
//     "Yesterday Only": [moment(start).subtract(1, "days"), moment(end).subtract(1, "days")],
//     "3 Days": [moment(start).subtract(3, "days"), moment(end)]
//   }
//   let local = {
//     "format": "DD-MM-YYYY HH:mm",
//     "sundayFirst": false,
//     days: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'So'],
//     months: [
//       'January',
//       'February',
//       'March',
//       'April',
//       'May',
//       'June',
//       'July',
//       'August',
//       'September',
//       'October',
//       'November',
//       'December',],
//     fromDate: 'From Date',
//     toDate: 'To Date',
//     selectingFrom: 'Selecting From',
//     selectingTo: 'Selecting To',
//     maxDate: 'Max Date',
//     close: 'Close',
//     apply: 'Apply',
//     cancel: 'Cancel'
//   }

//   function applyCallback(startDate, endDate) {
//     this.setState({
//       start: startDate,
//       end: endDate
//     }
//     )
//   }

//   function yearWiseCaller(stdate, from) {
//     console.log(stdate, "yearWiseCaller", "logger")

//     let minDate = moment(stdate).startOf("year")
//     let maxDate = moment(stdate).endOf("year")
//     setChangeWeek(minDate.format("yyyy"))
//     setWeekName("Year ")
//     commonapicaller(minDate, maxDate, from)
//   }
//   function rangeWiseCaller(updateDate, from) {

//     console.log("setDateRange", updateDate)
//     let minDate = moment(updateDate[0])
//     if (updateDate[1] != null) {
//       let maxDate = moment(updateDate[1])
//       commonapicaller(minDate, maxDate, from)
//       setWeekName("From ")
//       setChangeWeek(minDate.format("MM/DD/yyyy")+" To "+maxDate.format("MM/DD/yyyy"))
//     }

//     console.log(dateRange, "yearWiseCaller", "logger")
//     console.log(dateRange, "")
//   }
//   function quaterWiseCaller(date, from) {
//     let minDate = moment(date).startOf("quarter")
//     let maxDate = moment(date).endOf("quarter")
//     commonapicaller(minDate, maxDate, from)
//     setChangeWeek(minDate.format("Q") + ", Year "+minDate.format("yyyy"))
//     setWeekName("Quater")
//     console.log(date, "quaterWiseCaller", "logger")
//   }
//   function monthWiseCaller(date, from) {
//     let minDate = moment(date).startOf("month")
//     let maxDate = moment(date).endOf("month")
//     setChangeWeek(minDate.format("MMMM")+ ", Year "+minDate.format("yyyy"))
//     setWeekName("Month ")
//     commonapicaller(minDate, maxDate, from)
//   }
//   function weekWiseCaller(nowe, from) {
//     console.log(nowe.target.value, startDate, "nowe", "")
//     let minDate = moment().year(nowe.target.value.split("-")[0]).week(nowe.target.value.split("-")[1].replace("W","")).startOf("week").isoWeekday(1)
//     let maxDate = moment().year(nowe.target.value.split("-")[0]).week(nowe.target.value.split("-")[1].replace("W","")).endOf("week").isoWeekday(1)
//     console.log(moment().week, maxDate, "maxDatemaxDate")
//     setChangeWeek(nowe.target.value.split("-")[1].replace("W","")+", Year "+minDate.format("yyyy"))
//     setWeekName("Week ")
//     commonapicaller(minDate, maxDate, from)
//   }

//   function commonapicaller(apiStartDate, apiEndDate, from) {

//     console.log("logger",apiStartDate.week(),apiStartDate.format("MM/DD/YYYY HH:mm:SS"), apiEndDate.format("MM/DD/YYYY"))
//     dispatch(GetChartAction(`${from}`, `?start=${apiStartDate.format("MM/DD/YYYY_hh:mm:ss")}&end=${apiEndDate.format("MM/DD/YYYY_hh:mm:ss")}`))
//   }

//   // let maxDate = moment(start).add(24, "hour")

//   useEffect(() => {

//     console.log("ttCountVendor", ttCountVendor)
//     var currentDateR = moment();
//     var weekStart = currentDateR.clone().startOf('isoWeek');
//     var weekEnd = currentDateR.clone().endOf('isoWeek');

//     dispatch(GetChartAction(`${ttCountVendor}`, `?start=${weekStart.format("MM/DD/YYYY_hh:mm:ss")}&end=${weekEnd.format("MM/DD/YYYY_hh:mm:ss")}`))
//     // dispatch(GetChartAction(ttCountVendor, ""))
//     dispatch(GetChartAction(dashboardVendor, ""))
//     dispatch(GetChartAction(ttAgingVendor, ""))
//   }, [notchangeWeek])
//   return (
//     <>
//       <div className="row">
//         <div className="col-xl-6 col-md-6 col-lg-6 boxcol">
//           <div className="card ticket-bx">
//             <div className="card-body" style={{ padding: "0.875rem" }}>
//               <div className="d-sm-flex d-block pb-sm-3 align-items-end">

//                 <div className="mr-auto pr-3 mb-2 mb-sm-0">
//                   <span className="text-white  font-w200 d-block mb-sm-3 mb-2"><b>Today TT Opened</b></span>
//                   <h2 className="fs-40 text-white mb-0">{count.ticketsData ? count.ticketsData.todayOpen : "--"}<span className=" ml-2">Tickets</span></h2>
//                 </div>
//                 <div className="d-flex flex-wrap ftsize">
//                   {type == 1 ? <TrendingUpIcon fontSize='inherit' /> : ""}
//                   {type == 2 ? <TrendingDownIcon fontSize='inherit' /> : ""}

//                   <div className="ml-3">
//                     <p className="text-warning  mb-0">{percent}</p>
//                     <span className="fs-12">than last day</span>
//                   </div>
//                 </div>
//               </div>
//               <div className="progress mt-3 mb-4" style={{ height: "15px" }}>
//                 <div className="progress-bar-striped progress-bar-animated" style={{ width: "86%", height: "15px" }} role="progressbar">
//                   <span className="sr-only">86% Complete</span>
//                 </div>
//               </div>
//               {/* <p className="fs-12">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad mini</p> */}
//               {/* <Link to={"#"} className="text-white">View detail<i className="las la-long-arrow-alt-right scale5 ml-3"></i></Link> */}
//             </div>
//             <div className="card-body" style={{ padding: "0.875rem" }}>
//               <div className="d-sm-flex d-block pb-sm-3 align-items-end">
//                 <div className="mr-auto pr-3 mb-2 mb-sm-0">
//                   <span className="text-white  font-w200 d-block mb-sm-3 mb-2 "><b>Total  TT's Open</b></span>
//                   <h2 className="fs-40 text-white mb-0">{count.ticketsData ? count.ticketsData.totalOpen : "--"}<span className=" ml-2">Tickets</span></h2>
//                 </div>

//               </div>
//             </div>
//           </div>

//         </div>

//         <div className="col-xl-6 col-md-6 col-lg-6 boxcol">

//           <div className="card border card-border-blue">
//             <div className="card-body card-body-custom">
//               <div className='form-group d-flex justify-content-start'>
//                 {/* <label className='mx-2'>Week</label>
//                 <select onChange={(e) => changeWeekF(e)} style={{ width: '20%' }}>
//                   {count.weekks}
//                 </select>
//                  */}
//                 {/* <div>
//                   <DateTimeRangeContainer
//                     smartMode={true}
//                     noMobileMode={true}
//                     ranges={ranges}
//                     start={start}
//                     end={end}
//                     local={local}
//                     maxDate={maxDate}
//                     style={{ display: 'flex' }}
//                     applyCallback={applyCallback}
//                   >
//                     <FormControl
//                       id="formControlsTextB"
//                       type="text"
//                       label="Text"
//                       placeholder="Enter text"
//                     />
//                   </DateTimeRangeContainer>
//                 </div> */}

//                 <div className='row row-custom'>
//                   <div className='col-4 one-line-col1 pd-0'>
//                     <label>Select Date</label>
//                     <DatePicker
//                       selectsRange={true}
//                       placeholderText={"Select Date"}
//                       startDate={rangestartDate}
//                       endDate={rangeendDate}
//                       onChange={(update) => {
//                         setDateRange(update);
//                         rangeWiseCaller(update, ttCountVendor)
//                       }}
//                     />

//                   </div>
//                   <div className='col-2 one-line-col2 pd-0'>
//                     <label>Year</label>
//                     <DatePicker
//                       selected={startDate}
//                       onChange={(date) => {
//                         setStartDate(date)
//                         yearWiseCaller(date, ttCountVendor)
//                       }}
//                       showYearPicker
//                       placeholderText='Select'
//                       dateFormat="yyyy"

//                     />
//                   </div>
//                   <div className='col-3 one-line-col3 pd-0'>
//                     <label>Quarter</label>
//                     <DatePicker
//                       selected={startDate}
//                       onChange={(date) => {
//                         setStartDate(date)
//                         quaterWiseCaller(date, ttCountVendor)
//                       }}
//                       dateFormat="yyyy, QQQ"
//                       placeholderText='Select'
//                       showQuarterYearPicker
//                     />

//                   </div>

//                   <div className='col-3 one-line-col4 pd-0'>
//                     <label>Month</label>
//                     <DatePicker
//                       selected={startDate}
//                       onChange={(date) => {
//                         setStartDate(date)
//                         monthWiseCaller(date, ttCountVendor)
//                       }}
//                       dateFormat="MMM/yyyy"
//                       placeholderText='Select'
//                       showMonthYearPicker
//                     />

//                   </div>

//                   <div className='col-2 one-line-col5 pd-0'>
//                     <label>Week</label>

//                   <div class="react-datepicker-wrapper">
//                     <div class="react-datepicker__input-container">

//                       <input type='week'
//                         placeholder='Select Week'
//                         style={{height: "32.5px"}}
//                         onChange={(date) => {
//                           weekWiseCaller(date, ttCountVendor)
//                         }}
//                       />
//                     </div>
//                   </div>

//                   </div>

//                 </div>
//               </div>
//               <div className="mixed-chart ">
//                 <Chart
//                   options={ttvardata.options}
//                   series={ttvardata.series}
//                   type="bar"
//                   height={300}
//                 />

//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="col-xl-6 col-md-6 col-lg-6 boxcol">
//           <div className="card border card-border-blue">
//             <div className="card-body card-body-custom">
//               <div className='form-group d-flex justify-content-start'>
//                 {/* <label className='mx-2'>Week</label>
//             <select onChange={(e) => changeWeekF(e)} style={{ width: '20%' }}>
//               {count.weekks}
//             </select> */}

//                 {/* <div className='row row-custom'>
//                   <div className='col-4 one-line-col1 pd-0'>
//                     <DatePicker
//                       selectsRange={true}
//                       startDate={rangestartDate}
//                       endDate={rangeendDate}
//                       onChange={(update) => {
//                         setDateRange(update);
//                         rangeWiseCaller(update, ttAgingVendor)
//                       }}
//                     />

//                   </div>
//                   <div className='col-2 one-line-col2 pd-0'>
//                     <DatePicker
//                       selected={startDate}
//                       onChange={(date) => {
//                         setStartDate(date)
//                         yearWiseCaller(date, ttAgingVendor)
//                       }}
//                       showYearPicker
//                       dateFormat="yyyy"

//                     />
//                   </div>
//                   <div className='col-3 one-line-col3 pd-0'>
//                     <DatePicker
//                       selected={startDate}
//                       onChange={(date) => {
//                         setStartDate(date)
//                         quaterWiseCaller(ttAgingVendor)
//                       }}
//                       dateFormat="yyyy, QQQ"
//                       showQuarterYearPicker
//                     />

//                   </div>

//                   <div className='col-3 one-line-col4 pd-0'>

//                     <DatePicker
//                       selected={startDate}
//                       onChange={(date) => {
//                         setStartDate(date)
//                         monthWiseCaller(ttAgingVendor)
//                       }}
//                       dateFormat="MM/yyyy"
//                       showMonthYearPicker
//                     />
//                   </div>

//                   <div className='col-2 one-line-col5 pd-0'>
//                     <select onChange={(e) => {
//                       changeWeekF(e)
//                       weekWiseCaller(ttAgingVendor)
//                     }}>
//                       {count.weekks}
//                     </select>

//                   </div>

//                 </div> */}
//               </div>
//               <div className="mixed-chart ">

//                 <Chart
//                   options={agingvardata.options}
//                   series={agingvardata.series}
//                   type="bar"
//                   height={350}
//                 />

//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   )
// }

// export default VendorDashboard;

import React, { useEffect, useState } from "react";
// import { Dropdown } from 'react-bootstrap'
// import "../../../css/customStyle.css"
// // import DataTable, { createTheme } from 'react-data-table-component';
// // import DataTableExtensions from 'react-data-table-component-extensions';
// import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
// // import { NetworkDatabaseAction, CSVUploadAction, PAG_maindashboardAction } from "../../../store/actions/dashboardActions"
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
// // import DateTimeRangeContainer from 'react-advanced-datetimerange-picker'
// // import { FormControl } from 'react-bootstrap'
import moment from "moment";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
// import "react-datepicker/dist/react-datepicker.css";

// import "../../../css/custom.css"

// // fusion starts
// // import FusionCharts from "fusioncharts/core";
// // import candyTheme from "fusioncharts/themes/fusioncharts.theme.candy";
// // import FusionCharts from "fusioncharts";
// // import charts from "fusioncharts/fusioncharts.charts";
// // import ReactFusioncharts from "react-fusioncharts";
import candyTheme from "fusioncharts/themes/fusioncharts.theme.candy";
import FusionCharts from "fusioncharts";
import ReactFusioncharts from "react-fusioncharts";
import charts from "fusioncharts/fusioncharts.charts";
// // fusion ends

// // import { Chart } from "react-google-charts";
// // import Chart from 'react-apexcharts';
import {
  GetChartAction,
  GetChartAction1,
  GetChartAction2,
  GetChartAction3,
  PostChartAction1,
} from "../../../store/actions/createTicketManageFields";
import {
  dashboardVendor,
  ttAgingVendor,
  ttCountVendor,
  ttCountDashbordtable,
  ttMonthDashboardtable,
  ttWeekDashboardtable,
  ttDayDashboardtable,
} from "../../../common/config";
import DatePicker from "react-datepicker";
import TableDashboard, {
  TableDashboardAdv,
  TableNewDashboardAdv,
  TableNewDashboardAdvc,
} from "../../../common/TableDashboard";
import { funct } from "../../../common/commondata";
import { MultiSelect } from "react-multi-select-component";
import Swal from "sweetalert2";
import swal from "sweetalert";
import { TurnRight } from "@mui/icons-material";
// // import { CustomInput } from 'reactstrap';

// // Resolves charts dependancy
ReactFusioncharts.fcRoot(FusionCharts, charts, candyTheme);
// // charts(FusionCharts);
// // Register the candy theme
// // FusionCharts.addDep(candyTheme);
const VendorDashboard = () => {
  // chart starts

  // useEffect(() => {
  //  fetch('http://127.0.0.1:8095/PAG/ran/siteStatus' , {

  //  }).then(res => {
  //   console.warn('site status =>>' , res?.data)
  //  }).catch(err => console.log(err))
  // } , [])

  //  charts ends

  var tableToCsv = require("node-table-to-csv");

  let htmlTable =
    "<table>" +
    "<tr> <th>r1c1</th> <td>r1c2</td> <td>r1c3</td> </tr>" +
    "<tr> <th>r2c1</th> <td>r2c2</td> <td>r2c3</td> </tr>" +
    "<tr> <th>r3c1</th> <td>r3c2</td> <td>r3c3</td> </tr>" +
    "</table>";

  let csv = tableToCsv(htmlTable);

  console.log(csv, "tableToCsv");

  let now = new Date();
  let startt = moment(
    new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0)
  );
  let endd = moment(startt).add(1, "days").subtract(1, "seconds");
  const [accordianState, setAccordianState] = useState(false);

  let [sImpact, setSectorImpact] = useState([]);

  let [expoday, setexpoday] = useState("");
  let [expomonth, setexpomonth] = useState("");
  let [expoweek, setexpoweek] = useState("");
  let [sImpactweek, setImpactweek] = useState([]);

  const [weekRange, setweekRange] = useState([null, null]);

  const [tableData1, settableData1] = useState({
    headers: ["Totals", "RTWP Analysis", "Open", "Close"],
    data: [],
  });
  const [tableData2, settableData2] = useState({
    headers: ["Totals", "RTWP Analysis", "Open", "Close"],
    data: [],
  });
  const [tableData3, settableData3] = useState({
    headers: ["Capex", "RTWP Analysis", "Open", "Close"],
    data: [],
  });
  const [monthData1, setmonthData1] = useState({
    headers: ["Totals", "RTWP Analysis", "Open", "Close"],
    data: [],
  });
  const [monthData2, setmonthData2] = useState({
    headers: ["Opex", "RTWP Analysis", "Open", "Close"],
    data: [],
  });
  const [monthData3, setmonthData3] = useState({
    headers: ["Capex", "RTWP Analysis", "Open", "Close"],
    data: [],
  });
  // week
  const [weekData1, setweekData1] = useState({
    headers: ["Totals", "RTWP Analysis", "Open", "Close"],
    data: [],
  });
  const [weekData2, setweekData2] = useState({
    headers: ["Opex", "RTWP Analysis", "Open", "Close"],
    data: [],
  });
  const [weekData3, setweekData3] = useState({
    headers: ["Capex", "RTWP Analysis", "Open", "Close"],
    data: [],
  });

  // day

  const [dayData1, setdayData1] = useState({
    headers: ["Totals", "RTWP Analysis", "Open", "Close"],
    data: [],
  });
  const [dayData2, setdayData2] = useState({
    headers: ["Opex", "RTWP Analysis", "Open", "Close"],
    data: [],
  });
  const [dayData3, setdayData3] = useState({
    headers: ["Capex", "RTWP Analysis", "Open", "Close"],
    data: [],
  });

  // const [tableData4, settableData4] = useState( {
  //   headers: ["Totals", "RTWP Analysis", "Open","Close"],
  //   data: [
  //     [1, "John", 30],
  //     [2, "Jane", 25],
  //     // Add more data rows as needed
  //   ],
  // })

  const [oneTime, setoneTime] = useState(true);
  const [oneTime1, setoneTime1] = useState(true);
  const [siteFile, uploadedFile] = useState();
  const [remarks, setRemarks] = useState();
  const [changeWeek, setChangeWeek] = useState();
  const [notchangeWeek, setnotchangeWeek] = useState();
  const [Week, setWeekName] = useState("Year");
  const [adingDate, setadingDate] = useState();
  const [start, setstart] = useState(startt);
  const [end, setend] = useState(endd);
  const [startDate, setStartDate] = useState();
  const [oneLoad, setOneLoad] = useState(true);
  const [monthOneLoad, setmonthOneLoad] = useState(true);
  const [weekOneLoad, setweekOneLoad] = useState(true);
  const [dayOneLoad, setdayOneLoad] = useState(true);

  const [fstartdate, setFStartDate] = useState(null);
  // console.log(fstartdate,"djsds")
  const [fenddate, setFEndDate] = useState(null);

  // const [oneLoad1, setOneLoad1] = useState(true);

  const [dateRange, setDateRange] = useState([null, null]);

  const [monthDate, setMonthDate] = useState(now);
  const [dayDate, setDayDate] = useState(now);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [rangestartDate, rangeendDate] = dateRange;
  const [sectorsImpactedWeek, setsectorsImpactedWeek] = useState([]);

  const [selectedWeeks, setSelectedWeeks] = useState([]);
  console.log(selectedWeeks);

  const handleWeekSelection = (selectedOptions) => {
    setSelectedWeeks(selectedOptions);
    const selectedValues = selectedOptions.map((week) =>
      parseInt(week.value, 10)
    );
    selectedValues.forEach((week) => {
      weekWiseCaller(week, ttWeekDashboardtable);
    });
  };

  const options = Array.from({ length: 52 }, (_, i) => ({
    value: (i + 1).toString(),
    label: `Week ${i + 1}`,
  }));

  let columns = [];

  let morethanenew = [];
  let lessthannew = [];
  let assignvendornew = [];
  let rowData = [];
  var posts = [];
  var new_posts = [];
  var tableData_new = {};

  var TotalTicket = "--";
  var piechartdata = [["Task", "Hours per Day"]];

  var piechartoptions = {
    is3D: true,
    backgroundColor: "transparent",
    responsive: true,

    legend: {
      position: "right",
      textStyle: { fontSize: 10, color: "black" },
    },
  };

  var downtable_columns = [];
  var downtable_data = [];

  var unique_weeks = [];
  var vendor = [];
  var open = [];
  var close = [];
  var chartTable1 = [];

  var monthTable1 = [];

  const count = useSelector((state) => {
    let vendornew = [];
    let opennew = [];

    let closenew = [];

    let weekks = [];
    let ticketsData;
    console.log(state.chartState.chartTable1, "state");

    chartTable1 = state.chartState.chartTable1;
    let chartTable2 = state.chartState.chartTable2;

    let chartTable3 = state.chartState.chartTable3;

    let monthTable1 = state.chartState.monthTable1;
    let monthTable2 = state.chartState.monthTable2;
    let monthTable3 = state.chartState.monthTable3;

    let weekTable1 = state.chartState.weekTable1;
    let weekTable2 = state.chartState.weekTable2;
    let weekTable3 = state.chartState.weekTable3;

    let dayTable1 = state.chartState.dayTable1;
    let dayTable2 = state.chartState.dayTable2;
    let dayTable3 = state.chartState.dayTable3;

    let header1 = [];
    let column1 = [];
    let open1 = [];
    let close1 = [];
    // let data1 = funct(chartTable1);
    // let data2 = funct(chartTable2);
    // let data3 = funct(chartTable3);
    // let monthdata1 = funct(monthTable1);
    // let monthdata2 = funct(monthTable2);
    // let monthdata3 = funct(monthTable3);
    // // ?week
    // let weekdata1 = funct(weekTable1);
    // let weekdata2 = funct(weekTable2);
    // let weekdata3 = funct(weekTable3);

    // let daydata1 = funct(dayTable1);
    // let daydata2 = funct(dayTable2);
    // let daydata3 = funct(dayTable3);

    // if (oneLoad && data1.length > 0) {
    //   settableData1({
    //     headers: ["Totals", "RTWP Analysis", "Open", "Close"],
    //     data: data1,
    //   });
    //   settableData2({
    //     headers: ["Opex", "RTWP Analysis", "Open", "Close"],
    //     data: data2,
    //   });
    //   settableData3({
    //     headers: ["Capex", "RTWP Analysis", "Open", "Close"],
    //     data: data3,
    //   });

    //   setOneLoad(false);
    // }
    // // month
    // if (monthOneLoad && monthdata1.length > 0) {
    //   setmonthData1({
    //     headers: ["Totals", "RTWP Analysis", "Open", "Close"],
    //     data: monthdata1,
    //   });
    //   setmonthData2({
    //     headers: ["Opex", "RTWP Analysis", "Open", "Close"],
    //     data: monthdata2,
    //   });
    //   setmonthData3({
    //     headers: ["Capex", "RTWP Analysis", "Open", "Close"],
    //     data: monthdata3,
    //   });

    //   setmonthOneLoad(false);
    // }
    // // week
    // if (weekOneLoad && weekdata1.length > 0) {
    //   setweekData1({
    //     headers: ["Totals", "RTWP Analysis", "Open", "Close"],
    //     data: weekdata1,
    //   });
    //   setweekData2({
    //     headers: ["Opex", "RTWP Analysis", "Open", "Close"],
    //     data: weekdata2,
    //   });
    //   setweekData3({
    //     headers: ["Capex", "RTWP Analysis", "Open", "Close"],
    //     data: weekdata3,
    //   });

    //   setweekOneLoad(false);
    // }

    // // day

    // if (dayOneLoad && daydata1.length > 0) {
    //   setdayData1({
    //     headers: ["Totals", "RTWP Analysis", "Open", "Close"],
    //     data: daydata1,
    //   });
    //   setdayData2({
    //     headers: ["Opex", "RTWP Analysis", "Open", "Close"],
    //     data: daydata2,
    //   });
    //   setdayData3({
    //     headers: ["Capex", "RTWP Analysis", "Open", "Close"],
    //     data: daydata3,
    //   });

    //   setdayOneLoad(false);
    // }

    console.log(header1, close1, open1, "header1");
    if (
      state.chartState.ttVendorChartData &&
      state.chartState.ttVendorChartData.length > 0
    ) {
      let rowData = state.chartState.ttVendorChartData
        ? state.chartState.ttVendorChartData.length > 0
          ? state.chartState.ttVendorChartData
          : []
        : [];
      let agingrowData = state.chartState.ttVendorAgingChartData
        ? state.chartState.ttVendorAgingChartData.length > 0
          ? state.chartState.ttVendorAgingChartData
          : []
        : [];

      ticketsData = state.chartState.vendorDashboard
        ? state.chartState.vendorDashboard
        : {};

      console.log(ticketsData, "ticketsDataticketsDataticketsData");

      if (oneTime1 == oneTime1) {
        if (agingrowData && agingrowData.length > 0) {
          // setoneTime1(false)
          console.log("agingrowData", agingrowData);
          agingrowData.map((item) => {
            let inner = item.add;
            console.log("agingrowDatainner", inner);

            if (inner.length == 2) {
              if (inner[0].status == "greater") {
                morethanenew.push(inner[0].count);
              }
              if (inner[0].status == "less") {
                lessthannew.push(inner[0].count);
              }
              if (inner[1].status == "greater") {
                morethanenew.push(inner[1].count);
              }
              if (inner[1].status == "less") {
                lessthannew.push(inner[1].count);
              }
            }
            if (inner.length == 1) {
              if (inner[0].status == "less") {
                lessthannew.push(inner[0].count);
                morethanenew.push(0);
              }
              if (inner[0].status == "greater") {
                morethanenew.push(inner[0].count);
                lessthannew.push(0);
              }
            }
            if (inner.length == 0) {
              morethanenew.push(0);
              lessthannew.push(0);
            }
            assignvendornew.push(item._id.vendor);
          });
        }
      }

      if (rowData) {
        rowData.map((item) => {
          console.log(
            item.vendor,
            item.weekNumber == "08",
            "item.weekNumber==08",
            item.status
          );
          if (unique_weeks.indexOf(item.weekNumber) > -1) {
            unique_weeks.push(item.weekNumber);
          }

          if (1 == 1) {
            console.log(item.data, "item.data");
            let inner = item.data;

            // console.log(inner[0].status == "Close", "inner");
            if (inner?.length == 2) {
              console.log(inner[0].status, "innerstatus");
              if (inner[0].status == "CAPEX") {
                // console.log(inner[0].count, "innerstatus");
                opennew.push(inner[0].count);
              }
              if (inner[0].status == "OPEX") {
                // console.log(inner[0].count, "innerstatus");
                closenew.push(inner[0].count);
              }

              if (inner[1].status == "CAPEX") {
                // console.log(inner[1].count, "innerstatus");
                opennew.push(inner[1].count);
              }
              if (inner[1].status == "OPEX") {
                // console.log(inner[1].count, "innerstatus");
                closenew.push(inner[1].count);
              }
            }

            if (inner?.length == 1) {
              // console.log(inner[0].status, "innerstatus");
              if (inner[0].status == "CAPEX") {
                console.log(inner[0].count, "innerstatus");
                opennew.push(inner[0].count);
                closenew.push(0);
              }
              if (inner[0].status == "OPEX") {
                console.log(inner[0].count, "innerstatus");
                closenew.push(inner[0].count);
                opennew.push(0);
              }
            }

            if (inner?.length == 0) {
              closenew.push(0);
              opennew.push(0);
            }

            vendornew.push(item._id.vendor);
            console.log(opennew, closenew, vendornew, "innerdsadaas");
          }
        });
      }
    }

    // for (let i = 1; i <= 52; i++) {
    //   let weekday = "0" + i.toString();
    //   if (changeWeek == weekday) {
    //     weekks.push(
    //       <option selected value={i < 10 ? "0" + i.toString() : i.toString()}>
    //         {i < 10 ? "0" + i.toString() : i.toString()}
    //       </option>
    //     );
    //   } else {
    //     weekks.push(
    //       <option value={i < 10 ? "0" + i.toString() : i.toString()}>
    //         {i < 10 ? "0" + i.toString() : i.toString()}
    //       </option>
    //     );
    //   }
    // }

    return {
      opennew,
      closenew,
      vendornew,
      weekks,
      ticketsData,
      lessthannew,
      morethanenew,
      assignvendornew,
      monthTable1,
      monthTable2,
      monthTable3,
      dayTable1,
      dayTable2,
      dayTable3,
      weekTable1,
      weekTable2,
      weekTable3,
    };
  });

  // const [dataSource, setDataSource] = useState({
  //   chart: {
  //     caption: "Total Opened Trouble Tickets",
  //     // subcaption: " Top 5 Developed Countries",
  //     // numbersuffix: "%",
  //     // showsum: "1",
  //     plottooltext:
  //       "$label produces <b>$dataValue</b>",
  //     theme: "candy",
  //     drawcrossline: "1"
  //   },
  //   categories: [
  //     {
  //       category: [
  //         {
  //           label: "Today TT Opened"
  //         },
  //         {
  //           label: "Total  TT's Open"
  //         },
  //         {
  //           label: "TT ageing less than 48hrs"
  //         },
  //         {
  //           label: "TT ageing more than 48hrs"
  //         },
  //       ]
  //     }
  //   ],
  //   dataset: [
  //     {
  //       seriesname: "Today TT Opened",
  //       data: [
  //         {
  //           value: "400"
  //         },
  //         {
  //           value: "830"
  //         },
  //         {
  //           value: "500"
  //         },
  //         {
  //           value: "420"
  //         },
  //         {
  //           value: "790"
  //         },
  //         {
  //           value: "380"
  //         }
  //       ]
  //     },
  //     {
  //       seriesname: "Total  TT's Open",
  //       data: [
  //         {
  //           value: "350"
  //         },
  //         {
  //           value: "620"
  //         },
  //         {
  //           value: "410"
  //         },
  //         {
  //           value: "370"
  //         },
  //         {
  //           value: "720"
  //         },
  //         {
  //           value: "310"
  //         }
  //       ]
  //     },
  //     {
  //       seriesname: 'TT ageing less than 48hrs',
  //       data: count?.lessthannew || []
  //     },
  //     {
  //       seriesname: 'TT ageing more than 48hrs',
  //       data: count?.morethanenew || []
  //     }
  //   ]
  // })

  const dispatch = useDispatch();
  function accordianHandler() {
    setAccordianState(!accordianState);
  }

  let sectorsImpacted = [];

  const currentYear = new Date().getFullYear();
  const startYear = 2020;
  const yearsRange = [];
  for (let year = startYear; year <= currentYear; year++) {
    sectorsImpacted.push({ value: year, label: year });
  }

  console.log(yearsRange, "yearsRange");

  //   {
  //     value: "MPAG",
  //     label: "MPAG"
  //   },
  //   {
  //     value: "MOP",
  //     label: "MOP"
  //   },
  // ]

  const handleSectorImpect = (e) => {
    setSectorImpact(e);

    // alert(e)
    console.log(
      e.map((itm) => {
        return itm.value;
      }),
      "handleSectorImpect"
    );
    // setDepartmentError(false)
    // console.log(sImpact, "sImpact")
    // setsectorsImpactedWeek(e)

    let weekDates = [];
    let listweekDates = [];

    e.map((itm) => {
      const year = itm.value;
      weekDates.push({
        label: year,
        value: year,
        disabled: true,
      });
      const startOfYear = moment(year, "YYYY").startOf("year");
      const endOfYear = moment(year, "YYYY").endOf("year");

      let currentWeekStart = startOfYear.clone().startOf("isoWeek");

      while (currentWeekStart.isBefore(endOfYear)) {
        const currentWeekEnd = currentWeekStart.clone().endOf("isoWeek");
        weekDates.push({
          label:
            currentWeekStart.format("MM/DD/YYYY") +
            " TO " +
            currentWeekEnd.format("MM/DD/YYYY"),
          value:
            currentWeekStart.format("MM/DD/YYYY") +
            " 00:00 TO " +
            currentWeekEnd.format("MM/DD/YYYY") +
            " 23:59",
        });
        listweekDates.push(
          currentWeekStart.format("MM/DD/YYYY") +
            " 00:00 TO " +
            currentWeekEnd.format("MM/DD/YYYY") +
            " 23:59"
        );
        currentWeekStart.add(1, "week");
      }
    });

    setsectorsImpactedWeek(weekDates);

    console.log(weekDates, "weekDatesweekDatesweekDates");
  };

  const handleSectorImpectweek = (e) => {
    setImpactweek(e);
    let dtea = e.map((itm) => {
      return itm.value;
    });
    GetChartAction1(ttCountVendor);

    console.log(e, ttCountVendor, dtea, "handleSectorImpectweek");

    dispatch(PostChartAction1(ttCountVendor, { data: dtea }));
  };

  let ttvardata = {
    series: [
      {
        name: "Open",
        data: count.opennew,
      },
      {
        name: "Close",
        data: count.closenew,
      },
    ],
    options: {
      title: {
        // text: "Vendor TT Open Vs Closed " + Week + " " + changeWeek,
        text: "RTWP Analysis By Week",
        align: "left",
        margin: 10,
        offsetX: 0,
        offsetY: 0,
        floating: false,
        style: {
          fontSize: "10px",
          fontWeight: "bold",
          fontFamily: undefined,
          color: "#263238",
        },
      },
      chart: {
        // background: 'linear-gradient(135deg, #143b64 0%, #0655a8 100%)',
        background: "",
        dropShadow: {
          enabled: false,
          enabledOnSeries: undefined,
          top: 0,
          left: 0,
          blur: 3,
          color: "black",
          opacity: 1,
        },
        type: "bar",
        height: 250,
        toolbar: {
          show: true,
        },
      },

      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          // endingShape: "rounded",
        },
      },
      dataLabels: {
        enabled: true,
      },

      legend: {
        show: true,
        fontSize: "12px",
        fontWeight: 300,

        labels: {
          colors: "#000000",
        },
        position: "bottom",
        horizontalAlign: "center",
        markers: {
          width: 19,
          height: 19,
          strokeWidth: 0,
          radius: 19,
          margin: 1,
          strokeColor: "#fff",
          fillColors: ["#f16722", "#143b64"],
          offsetX: 0,
          offsetY: 0,
        },
      },
      yaxis: {
        labels: {
          formatter: function (val) {
            return val ? val.toFixed(0) : "";
          },
          style: {
            colors: "#000000",
          },
        },
      },
      // stroke: {
      //   show: true,
      //   width: 2,
      //   colors: ["black"],

      // },
      xaxis: {
        categories: count.vendornew,
        labels: {
          style: {
            colors: "#000000",
          },
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: true,
        },
      },
      // grid: {
      //   yaxis: {
      //     lines: {
      //       show: false
      //     },
      //   },
      // },
      fill: {
        colors: ["#f16722", "#143b64"],
        // backgroundColor:"#ff00ff",
        opacity: 1,
      },
      // tooltip: {
      //   y: {
      //     formatter: function (val) {
      //       return val + " Ticket";
      //     },
      //   },
      // },
    },
  };

  let agingvardata = {
    series: [
      {
        name: "Less Than 48 Hrs",
        data: count?.lessthannew || [],
      },
      {
        name: "More Than 48 Hrs",
        data: count?.morethanenew || [],
      },
    ],
    options: {
      title: {
        text: "Current TT Ageing As of " + adingDate,
        align: "left",
        margin: 10,
        offsetX: 0,
        offsetY: 0,
        floating: false,
        style: {
          fontSize: "14px",
          fontWeight: "bold",
          fontFamily: undefined,
          color: "#263238",
        },
      },
      chart: {
        // background: 'linear-gradient(135deg, #143b64 0%, #0655a8 100%)',
        background: "",
        dropShadow: {
          enabled: false,
          enabledOnSeries: undefined,
          top: 0,
          left: 0,
          blur: 3,
          color: "black",
          opacity: 1,
        },
        type: "bar",
        height: 250,
        toolbar: {
          show: true,
        },
      },

      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          // endingShape: "rounded",
        },
      },
      dataLabels: {
        enabled: true,
      },

      legend: {
        show: true,
        fontSize: "12px",
        fontWeight: 300,

        labels: {
          colors: "#000000",
        },
        position: "bottom",
        horizontalAlign: "center",
        markers: {
          width: 19,
          height: 19,
          strokeWidth: 0,
          radius: 19,
          margin: 1,
          strokeColor: "#fff",
          fillColors: ["#f16722", "#143b64"],
          offsetX: 0,
          offsetY: 0,
        },
      },
      yaxis: {
        labels: {
          formatter: function (val) {
            return val ? val.toFixed(0) : "";
          },
          style: {
            colors: "#000000",
          },
        },
      },
      // stroke: {
      //   show: true,
      //   width: 2,
      //   colors: ["black"],

      // },
      xaxis: {
        categories: count.assignvendornew,
        labels: {
          style: {
            colors: "#000000",
          },
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: true,
        },
      },
      // grid: {
      //   yaxis: {
      //     lines: {
      //       show: false
      //     },
      //   },
      // },
      fill: {
        colors: ["#f16722", "#143b64"],
        // backgroundColor:"#ff00ff",
        opacity: 1,
      },
      // tooltip: {
      //   y: {
      //     formatter: function (val) {
      //       return val + " Ticket";
      //     },
      //   },
      // },
    },
  };

  function changeWeekF(e, typ = undefined) {
    if (typ == "no") {
      console.log(e, "changeWeek");
      setChangeWeek(e);
    } else {
      console.log(e.target.value, "changeWeek");
      setChangeWeek(e.target.value);
    }
  }

  let percent = "--";
  let type = 0;
  console.log(count.ticketsData, "count.ticketsData");
  if (count.ticketsData) {
    if (oneTime && count.ticketsData.currentWeek) {
      setoneTime(false);
      // setChangeWeek(count.ticketsData.currentWeek)
      // changeWeekF(count.ticketsData.currentWeek, "no")
      // console.log(count.ticketsData.currentWeek, "count.ticketsData")
      setadingDate(count.ticketsData.adingDate);
    }

    if (count.ticketsData.yesterdayOpen == 0) {
      percent = count.ticketsData.todayOpen * 100;
      type = 1;
    } else if (count.ticketsData.todayOpen == 0) {
      percent = count.ticketsData.yesterdayOpen * 100;
      type = 2;
    } else if (count.ticketsData.todayOpen > count.ticketsData.yesterdayOpen) {
      percent =
        ((count.ticketsData.todayOpen - count.ticketsData.yesterdayOpen) /
          count.ticketsData.yesterdayOpen) *
        100;
      // percent = count.ticketsData.todayOpen * 100 / count.ticketsData.yesterdayOpen
      type = 1;
    } else if (count.ticketsData.todayOpen < count.ticketsData.yesterdayOpen) {
      // percent = count.ticketsData.yesterdayOpen * 100 / count.ticketsData.todayOpen
      percent =
        ((count.ticketsData.todayOpen - count.ticketsData.yesterdayOpen) /
          count.ticketsData.yesterdayOpen) *
        100;
      type = 2;
    } else if (count.ticketsData.todayOpen == count.ticketsData.yesterdayOpen) {
      percent = "100";
      percent = 0;
    }

    // percent = percent + "%"
    percent = percent.toFixed(2) + "%";
  }

  // let now = new Date();
  // let start = moment(new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0));
  // let end = moment(start).add(1, "days").subtract(1, "seconds");
  let ranges = {
    "Today Only": [moment(start), moment(end)],
    "Yesterday Only": [
      moment(start).subtract(1, "days"),
      moment(end).subtract(1, "days"),
    ],
    "3 Days": [moment(start).subtract(3, "days"), moment(end)],
  };
  let local = {
    format: "DD-MM-YYYY HH:mm",
    sundayFirst: false,
    days: ["Mo", "Tu", "We", "Th", "Fr", "Sa", "So"],
    months: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    fromDate: "From Date",
    toDate: "To Date",
    selectingFrom: "Selecting From",
    selectingTo: "Selecting To",
    maxDate: "Max Date",
    close: "Close",
    apply: "Apply",
    cancel: "Cancel",
  };

  function applyCallback(startDate, endDate) {
    this.setState({
      start: startDate,
      end: endDate,
    });
  }

  function yearWiseCaller(stdate, from) {
    console.log(stdate, "yearWiseCaller", "logger");

    let minDate = moment(stdate).startOf("year");
    let maxDate = moment(stdate).endOf("year");
    setChangeWeek(minDate.format("yyyy"));
    setWeekName("Year ");
    commonapicaller(minDate, maxDate, from);
  }
  function rangeWiseCaller(updateDate, from) {
    // alert('called')
    console.log("setDateRange", updateDate);
    let minDate = moment(updateDate[0]);
    console.log(minDate, "minddd");
    if (updateDate[1] != null) {
      // alert('hii')
      let maxDate = moment(updateDate[1]);
      // console.log(maxDate,minDate, 'mdddd')
      // console.log(minDate.format("MM/DD/YYYY") + " to " + maxDate.format("MM/DD/YYYY"), 'mdddd')

      setexpoday(
        minDate.format("MM/DD/YYYY") + " to " + maxDate.format("MM/DD/YYYY")
      );
      dispatch(
        GetChartAction3(
          from,
          `?start=${minDate.format("MM/DD/YYYY_hh:mm:ss")}&end=${maxDate.format(
            "MM/DD/YYYY_hh:mm:ss"
          )}`
        )
      );
      // commonapicaller(minDate, maxDate, from);
      // setWeekName("From ");
      // setChangeWeek(
      //   minDate.format("MM/DD/yyyy") + " To " + maxDate.format("MM/DD/yyyy")
      // );
    } else {
      console.log("date not found");
    }
  }
  function quaterWiseCaller(date, from) {
    let minDate = moment(date).startOf("quarter");
    let maxDate = moment(date).endOf("quarter");
    commonapicaller(minDate, maxDate, from);
    setChangeWeek(minDate.format("Q") + ", Year " + minDate.format("yyyy"));
    setWeekName("Quater");
    console.log(date, "quaterWiseCaller", "logger");
  }
  function monthWiseCaller(monthDateData, from) {
    console.log(monthDateData, "monthDateData");
    let a = monthDateData;

    // let aString = a.toString();
    // console.log(aString,"aString");
    let minDate = moment(monthDateData).startOf("month");
    let maxDate = moment(monthDateData).endOf("month");
    let monthYearString =
      minDate.format("MMMM") + ", Year " + minDate.format("yyyy");
    console.log(monthYearString, "monthYearString");
    setChangeWeek(minDate.format("MMMM") + ", Year " + minDate.format("yyyy"));
    setWeekName("Month ");
    // commonapicaller(minDate, maxDate, from);
    setexpomonth(minDate.format("MMMM YYYY"));
    dispatch(
      GetChartAction1(
        ttMonthDashboardtable,
        `?start=${minDate.format("MM/DD/YYYY_hh:mm:ss")}&end=${maxDate.format(
          "MM/DD/YYYY_hh:mm:ss"
        )}`
      )
    );
  }
  // function weekWiseCaller(nowe, from) {
  //   console.log("dkjhdsksd",
  //     nowe,
  //     "weekWiseCaller",
  //     moment().subtract(1, "weeks"),
  //     startDate,
  //     "nowe",
  //     ""
  //   );
  //   let minDate = moment()
  //     .subtract(nowe - 1, "weeks")
  //     .startOf("week")
  //     .isoWeekday(1);
  //   console.log("sajdkfshasda", minDate)
  //   let maxDate = moment()
  //     .subtract(0, "weeks")
  //     .endOf("week")
  //     .isoWeekday(0);

  //   // console.log(moment().week, maxDate, "maxDatemaxDate");
  //   console.log(minDate, maxDate, "maxDatemaxDate");

  //   // setChangeWeek(
  //   //   nowe.target.value.split("-")[1].replace("W", "") +
  //   //     ", Year " +
  //   //     minDate.format("yyyy")
  //   // );
  //   setWeekName("Week ");
  //   // commonapicaller(minDate, maxDate, from);
  //   setexpoweek(minDate.format("MM/DD/YYYY") + " to " + maxDate.format("MM/DD/YYYY"))
  //   dispatch(
  //     GetChartAction2(
  //       ttWeekDashboardtable,
  //       `?start=${minDate.format("MM/DD/YYYY_hh:mm:ss")}&end=${maxDate.format(
  //         "MM/DD/YYYY_hh:mm:ss"
  //       )}`
  //     )
  //   );
  // }

  function weekWiseCaller(nowe, from) {
    let minDate = moment(nowe[0]).startOf("week").isoWeekday(1);
    let maxDate = moment(nowe[1]).endOf("week").isoWeekday(0);
    minDate = minDate.clone().add(1, "week");

    // console.log(moment().week, maxDate, "maxDatemaxDate");
    console.log(minDate, maxDate, "maxDatemaxDate");

    // setChangeWeek(
    //   nowe.target.value.split("-")[1].replace("W", "") +
    //     ", Year " +
    //     minDate.format("yyyy")
    // );
    setWeekName("Week ");

    // if (minDate !== null && maxDate !== null) {
    //   // alert('djns');
    //   setIsDisabled(true);
    // }
    // commonapicaller(minDate, maxDate, from);
    setexpoweek(
      minDate.format("MM/DD/YYYY") + " to " + maxDate.format("MM/DD/YYYY")
    );
    dispatch(
      GetChartAction2(
        from,
        `?start=${minDate.format("MM/DD/YYYY_hh:mm:ss")}&end=${maxDate.format(
          "MM/DD/YYYY_hh:mm:ss"
        )}`
      )
    );
  }

  //   function weekWiseCaller(nowe, from) {
  //     console.log(nowe.target.value, startDate, "nowe", "")
  //     let minDate = moment().year(nowe.target.value.split("-")[0]).week(nowe.target.value.split("-")[1].replace("W","")).startOf("week").isoWeekday(1)
  //     let maxDate = moment().year(nowe.target.value.split("-")[0]).week(nowe.target.value.split("-")[1].replace("W","")).endOf("week").isoWeekday(1)
  //     console.log(moment().week, maxDate, "maxDatemaxDate")
  //     setChangeWeek(nowe.target.value.split("-")[1].replace("W","")+", Year "+minDate.format("yyyy"))
  //     setWeekName("Week ")
  //     commonapicaller(minDate, maxDate, from)
  //   }

  function commonapicaller(apiStartDate, apiEndDate, from) {
    dispatch(
      GetChartAction(
        `${from}`,
        `?start=${apiStartDate.format(
          "MM/DD/YYYY_hh:mm:ss"
        )}&end=${apiEndDate.format("MM/DD/YYYY_hh:mm:ss")}`
      )
    );
  }

  // let maxDate = moment(start).add(24, "hour")

  // const handledaterange = () => {
  //   if (fstartdate && fenddate) {
  //     dispatch(
  //       GetChartAction3(
  //         ttDayDashboardtable,
  //         `?start=${moment(fstartdate)
  //           .startOf("day")
  //           .format("MM/DD/YYYY_hh:mm:ss")}&end=${moment(fenddate)
  //             .endOf("day")
  //             .format("MM/DD/YYYY_hh:mm:ss")}`
  //       )
  //     );
  //        setexpoday(moment(fstartdate).startOf("day").format("MM/DD/YYYY") + " to " + moment(fenddate).endOf("day").format("MM/DD/YYYY"));
  //   }
  // };
  const handledaterange = () => {
    if (fstartdate && fenddate) {
      const formattedStartDate = moment(fstartdate)
        .startOf("day")
        .format("MM/DD/YYYY_HH:mm:ss");
      const formattedEndDate = moment(fenddate)
        .endOf("day")
        .format("MM/DD/YYYY_HH:mm:ss");

      dispatch(
        GetChartAction3(
          ttDayDashboardtable,
          `?start=${formattedStartDate}&end=${formattedEndDate}`
        )
      );

      const displayDateRange = `${moment(fstartdate)
        .startOf("day")
        .format("MM/DD/YYYY")} to ${moment(fenddate)
        .endOf("day")
        .format("MM/DD/YYYY")}`;
      setexpoday(displayDateRange);
    }
  };

  const clearrange = () => {
    setweekRange([null, null]);
    setFStartDate(null);
    setFEndDate(null);
    setMonthDate(null);
    setDateRange([null, null]);
  };

  useEffect(() => {
    console.log("ttCountVendor", ttCountDashbordtable);
    dispatch(
      GetChartAction(
        ttCountDashbordtable,
        `?start=${moment()
          .startOf("year")
          .format("MM/DD/YYYY_hh:mm:ss")}&end=${moment()
          .endOf("year")
          .format("MM/DD/YYYY_hh:mm:ss")}`
      )
    );

    dispatch(
      GetChartAction1(
        ttMonthDashboardtable,
        `?start=${moment()
          .startOf("month")
          .format("MM/DD/YYYY_hh:mm:ss")}&end=${moment()
          .endOf("month")
          .format("MM/DD/YYYY_hh:mm:ss")}`
      )
    );
    // console.log(moment().startOf("day").format("MM/DD/YYYY") + " to " + moment().endOf("day").format("MM/DD/YYYY"),"jksdj")
    // setexpoday(moment().startOf("day").format("MM/DD/YYYY") + " to " + moment().endOf("day").format("MM/DD/YYYY"));
    setexpomonth(moment().startOf("month").format("MMMM YYYY"));
    // setexpomonth(moment().startOf("month").format("MM/DD/YYYY")+" to "+moment().endOf("month").format("MM/DD/YYYY"))
    // dispatch(
    //   GetChartAction2(
    //     ttWeekDashboardtable,
    //     `?start=${moment()
    //       .startOf("week")
    //       .format("MM/DD/YYYY_hh:mm:ss")}&end=${moment()
    //       .endOf("week")
    //       .format("MM/DD/YYYY_hh:mm:ss")}`
    //   )
    // );

    // let minDate = moment().subtract(1, "weeks").startOf("week").isoWeekday(1);
    // let maxDate = moment().subtract(0, "weeks").endOf("week").isoWeekday(0);

    let minDate = moment().startOf("week").isoWeekday(1);
    // console.log("sajdkfshasda", minDate);
    let maxDate = moment().endOf("week").isoWeekday(1);
    console.log(minDate, maxDate, "maxDatemaxDatekadjkjs");
    // console.log(moment().week, maxDate, "maxDatemaxDate");
    // console.log(minDate, maxDate, "maxDatemaxDate");
    // setChangeWeek(
    //   nowe.target.value.split("-")[1].replace("W", "") +
    //     ", Year " +
    //     minDate.format("yyyy")
    // );
    setWeekName("Week ");
    // commonapicaller(minDate, maxDate, from);
    dispatch(
      GetChartAction2(
        ttWeekDashboardtable,
        `?start=${minDate.format("MM/DD/YYYY_hh:mm:ss")}&end=${maxDate.format(
          "MM/DD/YYYY_hh:mm:ss"
        )}`
      )
    );
    setexpoweek(
      minDate.format("MM/DD/YYYY") + " to " + maxDate.format("MM/DD/YYYY")
    );
    setexpomonth(moment().startOf("day").format("MMMM YYYY"));

    dispatch(
      GetChartAction3(
        ttDayDashboardtable,
        `?start=${moment()
          .startOf("day")
          .format("MM/DD/YYYY_hh:mm:ss")}&end=${moment()
          .endOf("day")
          .format("MM/DD/YYYY_hh:mm:ss")}`
      )
    );
  }, [notchangeWeek]);

  let vendorOpenClose = {
    chart: {
      // caption: "Vendor TT Open VS Closed - " + Week + " " + changeWeek,
      caption: "RTWP Analysis By Week",
      dataLabel: "1",
      captionFontSize: "12",
      dataLabelFontSize: "14",
      valueFontSize: 10,
      valuePosition: "outside",
      dataLabelFontBold: "1",
      dataLabelFontColor: "#ffffff",
      dataLabelPadding: "5",
      dataLabelPlacement: "middle",
      plottooltext: "<b>$label</b><br>Value: $value",
      theme: "candy",
      drawcrossline: "1",
      seriesNameFontSize: "12",
      exportEnabled: true,
      exportAtClient: true,
      exportfilename: "RTWP Analysis By Week - " + Week + " " + changeWeek,
    },

    categories: [
      {
        category: Array.isArray(count?.vendornew)
          ? count?.vendornew.map((data) => {
              console.log(data, "datadatadata");
              return {
                label: data + "",
                labelFontSize: "10",
              };
            })
          : [],
      },
    ],
    dataset: [
      {
        seriesname: "Capex",
        color: "#4ae036",
        data: Array.isArray(count?.opennew)
          ? count?.opennew.map((data) => {
              return {
                value: data,
                ...(+data !== 0 && { showValue: "1" }),
                color: "#4ae036",
              };
            })
          : [],
      },
      {
        seriesname: "Opex",
        color: "#FF00FF",
        data: Array.isArray(count?.closenew)
          ? count?.closenew.map((data) => {
              return {
                value: data,
                ...(+data !== 0 && { showValue: "1" }),
                color: "#FF00FF",
              };
            })
          : [],
      },
    ],
  };

  console.log(vendorOpenClose, "vendorOpenClose");

  let ageing = {
    chart: {
      caption: "Current TT Ageing of " + count?.ticketsData?.adingDate || "",
      dataLabel: "1",
      baseFontSize: "10",
      valueFontSize: 10,
      valuePosition: "outside",
      captionFontSize: "14",
      dataLabelFontSize: "14",
      dataLabelFontBold: "1",
      dataLabelFontColor: "#000000",
      dataLabelPadding: "5",
      dataLabelPlacement: "middle",
      plottooltext: "<b>$label</b><br>Value: $value",
      theme: "candy",
      drawcrossline: "1",
      seriesNameFontSize: "12",
      exportEnabled: true,
      exportAtClient: true,
      exportfilename:
        "Current TT Ageing of " + count?.ticketsData?.adingDate || "",
    },

    categories: [
      {
        category: Array.isArray(count?.assignvendornew)
          ? count?.assignvendornew?.map((data) => {
              return {
                label: data?.replace("Tower Team", "TT"),
                labelFontSize: "10",
              };
            })
          : [],
      },
    ],
    dataset: [
      {
        seriesname: "Less than 48 HRS",
        color: "#4ae036",
        data: Array.isArray(count?.lessthannew)
          ? count?.lessthannew.map((data) => {
              return {
                value: data,
                ...(+data !== 0 && { showValue: "1" }),
                color: "#4ae036",
              };
            })
          : [],
      },

      {
        seriesname: "More than 48 HRS",
        color: "#FF00FF",
        data: Array.isArray(count?.morethanenew)
          ? count?.morethanenew.map((data) => {
              return {
                value: data,
                ...(+data !== 0 && { showValue: "1" }),
                color: "#FF00FF",
              };
            })
          : [],
      },
    ],
  };

  console.warn("count => ", count);

  // const tablesData = [
  //   { data: count.monthTable1 },
  //   { data: count.monthTable2 },
  //   { data: count.monthTable3 }
  // ];

  return (
    <>
      {/* <div
        style={{
          marginBottom: "2rem",
          display: "grid",
          gridTemplateRows: "repeat(1 , 105px)",
          gridRowGap: "0.3rem",
          
        }}
      >
        <div
          className=""
          style={{ gridColumn: "span 1", gridRow: "span 4", padding: "0.4rem" }}
        > */}
      {/* <div className='d-flex justify-content-end' style={{ background: 'rgb(38, 42, 51)', color: "white", padding: "10px", paddingBottom: "2px" }}>
            <div style={{ cursor: "pointer", background: "black", width: "38px", height: "38px", borderRadius: "50%", padding: "8px" }}>
              <svg fill='white' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M4 19H20V12H22V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V12H4V19ZM14 9H19L12 16L5 9H10V3H14V9Z"></path></svg>
            </div>
          </div> */}
      {/* jdskas */}

      <div className="row">
        {console.log(
          vendorOpenClose.dataset[0].data.length &&
            vendorOpenClose.dataset[1].data.length,
          "hidata"
        )}
        <div
          className={`${
            (vendorOpenClose.dataset[0].data.length &&
              vendorOpenClose.dataset[1].data.length) >= 12
              ? "col-12"
              : "col-md-12"
          }`}
          style={{ marginLeft: "50px", paddingRight: "8rem" }}
        >
          <div
            className="form-group"
            style={{ background: "rgb(38, 42, 51)", color: "white" }}
          >
            {/* <div style={{ width: "29%", marginLeft: "30px" }}>
              <DatePicker
                selectsRange={true}
                className="newFormatting"
                placeholderText={"Select Week"}
                startDate={dateRange[0]}
                endDate={dateRange[1]}
                dateFormat="I/R"
                locale="en-GB"
                showWeekNumbers
                showWeekPicker
                onChange={(update) => {
                  console.log(update, moment(update[0]).startOf("week"), "updateupdateupdate")
                  console.log('Received update:', update);

                  // Check if update[0] and update[1] are not null before applying startOf and endOf operations
                  const newStartDate = update[0] ? moment(update[0]).startOf("isoWeek").toDate() : null;
                  const newEndDate = update[1] ? moment(update[1]).endOf('isoWeek').toDate() : null;

                  const newDateRange = [newStartDate, newEndDate];

                  setDateRange(newDateRange);
                  
                  rangeWiseCaller(newDateRange, ttCountVendor);
                }}
                shouldCloseOnSelect={false}
                calendarStartDay={1}
                calendarEndDay={6}
                weekDayClassName={(date) => {
                  return `custom-week-day-${date.getDay()}`;
                }}
              />
            </div> */}
            <div style={{ width: "29%", marginLeft: "30px" }}>
              <DatePicker
                selectsRange={true}
                className="newFormatting"
                placeholderText={"Select Week"}
                startDate={dateRange[0]}
                endDate={dateRange[1]}
                dateFormat="I/R"
                locale="en-GB"
                onKeyDown={(e) => e.preventDefault()}
                showWeekNumbers
                showWeekPicker
                onChange={(update) => {
                  console.log(
                    update,
                    moment(update[0]).startOf("week"),
                    "updateupdateupdate"
                  );
                  console.log("Received update:", update);

                  // Check if update[0] and update[1] are not null before applying startOf and endOf operations
                  const newStartDate = update[0]
                    ? moment(update[0]).startOf("isoWeek").toDate()
                    : null;
                  const newEndDate = update[1]
                    ? moment(update[1]).endOf("isoWeek").toDate()
                    : null;

                  const newDateRange = [newStartDate, newEndDate];
                  setDateRange(newDateRange);
                  // Check if both newStartDate and newEndDate are not null or blank before making the API call
                  if (newStartDate !== null && newEndDate !== null) {
                    rangeWiseCaller(newDateRange, ttCountVendor);
                  }
                }}
                shouldCloseOnSelect={false}
                calendarStartDay={1}
                calendarEndDay={6}
                weekDayClassName={(date) => {
                  return `custom-week-day-${date.getDay()}`;
                }}
              />
            </div>

            {/* <div className="d-flex">
              <div
                style={{
                  width: "50%",
                  height: '30%',
                  display: "grid",
                  gridTemplateColumns: "repeat(2, 1fr)",
                  gap: "2rem",
                }}
              >
                <MultiSelect
                  className="light newFormatting"
                  options={sectorsImpacted}
                  onChange={handleSectorImpect}
                  value={sImpact}
                />
                <MultiSelect  
                  className="light newFormatting"
                  options={sectorsImpactedWeek}
                  onChange={handleSectorImpectweek}
                  value={sImpactweek}
                />
                


              </div>

              
            </div> */}
          </div>
          <div className="">
            <ReactFusioncharts
              type="mscolumn2d"
              width="100%"
              height="260"
              dataFormat="JSON"
              dataSource={vendorOpenClose}
            />
          </div>
        </div>
      </div>

      {/* fusion chart */}

      {/* <div style={{ visibility: "none" }}>
        {setTimeout(() => {
          document
            .querySelectorAll("[pointer-events='bounding-box']")
            .forEach((data) => (data.style.display = "none"));
        }, 2020)}
      </div> */}
      {/* {setTimeout(()=>{document.querySelectorAll("[pointer-events='bounding-box']").forEach(data=>data.style.display="none")},2000)} */}

      {/* <div>
        {console.log(monthData1, "monthData1sjd")}
        {console.log(tableData1, "tableData1sjd")}
        {console.log(monthData2, "dhukhi")}
        {console.log(monthData3, "shyam")}

        <h1> Complete View </h1>
        <div className="row">
          <TableDashboard data={tableData1}></TableDashboard>
          <TableDashboard data={tableData2}></TableDashboard>
          <TableDashboard data={tableData3}></TableDashboard>
        </div>
      </div> */}

      <div className="d-flex" style={{marginTop:'5px',}}>
      <div
        onClick={() => {
          clearrange();
        }}
        style={{
          width: "20%",
          height: "35px",
          color: "slategray",
          borderRadius: "10px",
          backgroundColor: "#143B64",
          padding: "1px",
          color: "white ",
          padding: "7px",
          // display: "flex",
          // justifyContent: "center",
          alignItems: "right",
          cursor: "pointer",
          marginLeft:'90%'
        }}
      >
        Reset
      </div>
      <div
        className="text-right-container "
        style={{ width: "100%", marginRight: "auto" }}
      >
        {/* <div className="head">CAPEX DASHBOARD</div> */}
        <ReactHTMLTableToExcel
          id="test-table-xls-button"
          className="download-table-xls-button  text-right"
          table="table-to-xls"
          filename="Dashboard"
          sheet="Dashboard"
          buttonText="Export"
        />
      </div>
      </div>

      <div
        className="d-flex w-full"
        style={{ fontSize: "12px", textAlign: "left" }}
      >
        <div>
          <h3 style={{ marginLeft: "30px" }}> Month View </h3>

          <div style={{ width: "70%", marginLeft: "30px", font: "10px" }}>
            {/* <label style={{ color: "black", marginLeft: "23px" }}>
    Select Date
  </label> */}
            <DatePicker
              // selectsRange={true}
              // style={{marginLeft:"30px",color:"red"}}
              className="newFormatting"
              placeholderText="Select Month Date"
              selected={monthDate}
              dateFormat="MM/yyyy"
              onChange={(update) => {
                setMonthDate(update);
                monthWiseCaller(update, ttMonthDashboardtable);
              }}
              showMonthYearPicker
            />
          </div>

          <br />
          <div>
            <TableDashboard data={count.monthTable1}></TableDashboard>
            <TableDashboard data={count.monthTable2}></TableDashboard>
            <TableDashboard data={count.monthTable3}></TableDashboard>
            {console.log(expoday, "fffffff->")}
            <table
              id="table-to-xls"
              style={{ display: "None", justifyContent: "center" }}
            >
              <TableNewDashboardAdvc
                name1={"Month-" + expomonth}
                name2={"Week-" + expoweek}
                name3={"Day-" + expoday}
                data1={count.monthTable1}
                data2={count.weekTable1}
                data3={count.dayTable1}
              ></TableNewDashboardAdvc>
              <TableNewDashboardAdv
                name={""}
                data1={count.monthTable1}
                data2={count.weekTable1}
                data3={count.dayTable1}
              ></TableNewDashboardAdv>
              <TableNewDashboardAdv
                name={""}
                data1={count.monthTable2}
                data2={count.weekTable2}
                data3={count.dayTable2}
              ></TableNewDashboardAdv>
              <TableNewDashboardAdv
                name={""}
                data1={count.monthTable3}
                data2={count.weekTable3}
                data3={count.dayTable3}
              ></TableNewDashboardAdv>
            </table>
          </div>
        </div>

        <div>
          <h3 style={{ marginLeft: "23px" }}> Week View </h3>
          {/* <div class="react-datepicker-wrapper">
            <div
              class="react-datepicker__input-container"
              style={{ paddingLeft: "10px" }}
            >
              <input
                type="number"
                placeholder="Enter Week"
                className="newFormatting"
                min={1}
                max={52}
                defaultValue={1}
                style={{ height: "36px", width: "12rem",marginLeft:'15px'}}
                onChange={(date) => {
                  const enteredValue = date.target.value.trim();
                  date = parseInt(date.target.value)
                  console.log(date, "datedatedate");
                  // if (date <= 52  && date>=1) {
                  if (!isNaN(date) && date >= 1 && date <= 52) {
                    weekWiseCaller(date, ttWeekDashboardtable);
                  } else if (enteredValue !== '') {
                    swal({
                      title: "Oops.. !",
                      text: "Please select week beteen 1 to 52",
                      icon: "info",
                    })
                  }
                }}
              />
              <br />
            </div>
          </div> */}
          {/* <div className="react-datepicker-wrapper">
            <div className="react-datepicker__input-container" style={{ marginLeft: "23px", width: "180px", marginTop: '-4px !important' }}>
              <MultiSelect

                options={Array.from({ length: 52 }, (_, index) => ({ label: `Week ${index + 1}`, value: index + 1 }))}
                placeholderButtonLabel="Select Weeks"
                className="new"
                value={selectedWeeks}
                onChange={handleWeekSelection}
              />
              <br />
            </div>
          </div> */}

          <div
            style={{
              width: "29%",
              marginLeft: "30px",
              marginBottom: "20px",
              width: "180px",
            }}
          >
            <DatePicker
              selectsRange={true}
              className="newFormatting"
              placeholderText={"Select Week"}
              startDate={weekRange[0]}
              endDate={weekRange[1]}
              onKeyDown={(e) => e.preventDefault()}
              // disabled={true}
              dateFormat="I/R"
              locale="en-GB"
              showWeekNumbers
              showWeekPicker
              onChange={(update) => {
                let newDateRange = [];
                console.log(
                  update,
                  moment(update[0]).isValid(),
                  moment(update[0]).isValid(),
                  "moment(update[0]).isValid()"
                );

                const newStartDate = update[0]
                  ? moment(update[0]).startOf("isoWeek").toDate()
                  : null;
                newDateRange.push(newStartDate);
                const newEndDate = update[1]
                  ? moment(update[1]).endOf("isoWeek").toDate()
                  : null;
                newDateRange.push(newEndDate);

                // console.log(
                //   newDateRange,
                //   "newDateRangenewDateRangenewDateRangenewDateRange"
                // );

                setweekRange(newDateRange);
                weekWiseCaller(newDateRange, ttWeekDashboardtable);
              }}
              shouldCloseOnSelect={false}
              calendarStartDay={1}
              calendarEndDay={6}
              weekDayClassName={(date) => {
                return `custom-week-day-${date.getDay()}`;
              }}
            />
          </div>
          <div style={{ marginLeft: "10px", marginRight: "13px" }}>
            <TableDashboard data={count.weekTable1}></TableDashboard>
            <TableDashboard data={count.weekTable2}></TableDashboard>
            <TableDashboard data={count.weekTable3}></TableDashboard>
            {/* <TableDashboard data={tableData4}></TableDashboard> */}
          </div>
        </div>

        <div>
          <h3 style={{ marginLeft: "23px" }}> Date Range View </h3>
          {/* <div style={{ width: "22%", marginLeft: "30px" }}>
        <label style={{ color: "black", marginLeft: "23px" }}></label>
        <DatePicker
          selectsRange={true}
          className="newFormatting"
          placeholderText={"Select Date"}
          startDate={rangestartDate}
          endDate={rangeendDate}
          onChange={(update) => {
            setDateRange(update);
            rangeWiseCaller(update, ttDayDashboardtable);
          }}
        />
      </div> */}

          <div
            style={{
              width: "50vh",
              display: "flex",
              alignItems: "center",
              margin: "8px 20px 0px",
            }}
          >
            <DatePicker
              placeholderText="MM/DD/YYYY"
              id="color-of-datepicker"
              // className="newFormatting"
              className="newFormatting date-picker-changes  "
              // popperPlacement="left"
              selected={fstartdate}
              autoComplete="off"
              onChange={(date) => setFStartDate(date)}
              dateFormat="MM/dd/yyyy"
            />
            <DatePicker
              placeholderText="MM/DD/YYYY"
              // className="date-picker-changes mx-1"
              className="newFormatting date-picker-changes mx-1  "
              id="color-of-datepicker"
              // popperPlacement="right"
              autoComplete="off"
              selected={fenddate}
              onChange={(date) => setFEndDate(date)}
              dateFormat="MM/dd/yyyy"
            />

            {/* <div className="" style={{ marginLeft: '10px', marginRight: '5px' }}>
              <div
                onClick={() => {
                  handledaterange();
                }}
                style={{ width: "100%", height: "35px", color: 'slategray', borderRadius: "10px", backgroundColor: "#143B64", padding: '1px', color: 'white ', padding: '7px', display: "flex", justifyContent: 'center', alignItems: 'center', cursor: 'pointer', }}
              >
                Submit
              </div>
            </div>
          </div> */}
            <div
              className="d-flex gap-1rem"
              style={{ marginLeft: "8px", marginRight: "8px", gap: "0.4rem" }}
            >
              <div
                onClick={() => {
                  handledaterange();
                }}
                style={{
                  width: "100%",
                  height: "35px",
                  color: "slategray",
                  borderRadius: "10px",
                  backgroundColor: "#143B64",
                  padding: "1px",
                  color: "white ",
                  padding: "7px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                Submit
              </div>
            </div>
          </div>

          <br />
          <div style={{ marginLeft: "10px", marginRight: "13px" }}>
            <TableDashboard data={count.dayTable1}></TableDashboard>
            <TableDashboard data={count.dayTable2}></TableDashboard>
            <TableDashboard data={count.dayTable3}></TableDashboard>
            {/* <TableDashboard data={tableData4}></TableDashboard> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default VendorDashboard;
